import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store/store';
import { addditionalCalcParams, CommonSettings, DISTANCE_MEASURES, lossTypes, ONTS_TYPES, partsTypes, splitterIDs, splitterLoss, SPLITTERS_TYPES, TRANSCEIVERS_TYPES } from '../../settings';
import { notEmptyVal } from '../../tools';


const splittersData: any = {};

splitterIDs.forEach((num: number, i: number) => {
    splittersData[`splitters_loss_1x${num}`] = {
        val: "",
        gain_loss: splitterLoss[i]
    }
})

export const initialConfigState: any = {
    values: {
        ...splittersData,
        "transceiver_1": {
            val: "combo_pon",
            gain_loss: "Gain/Loss"
        },

        // Combo
        "xgs_pon_tx_comb_trans": {
            val: "",
            gain_loss: CommonSettings.hardware[partsTypes.TRANSCEIVERS][TRANSCEIVERS_TYPES.COMBO_PON].xgspon_min_dl_tx
        },
        "xgs_pon_rx_comb_trans_sens": {
            val: "",
            gain_loss: CommonSettings.hardware[partsTypes.TRANSCEIVERS][TRANSCEIVERS_TYPES.COMBO_PON].xgspon_min_dl_rx
        },
        "gpon_tx_comb_trans": {
            val: "",
            gain_loss: CommonSettings.hardware[partsTypes.TRANSCEIVERS][TRANSCEIVERS_TYPES.COMBO_PON].gpon_min_dl_tx
        },
        "gpon_rx_comb_trans_sens": {
            val: "",
            gain_loss: CommonSettings.hardware[partsTypes.TRANSCEIVERS][TRANSCEIVERS_TYPES.COMBO_PON].gpon_min_ul_rx
        },

        // XGS
        "xgs_pon_tx_xgs_trans": {
            val: "",
            gain_loss: CommonSettings.hardware[partsTypes.TRANSCEIVERS][TRANSCEIVERS_TYPES.XGS_PON].xgspon_min_dl_tx
        },
        "xgs_pon_rx_xgs_trans_sens": {
            val: "",
            gain_loss: CommonSettings.hardware[partsTypes.TRANSCEIVERS][TRANSCEIVERS_TYPES.XGS_PON].xgspon_min_dl_rx
        },

        // GPON
        "gpon_tx_gpon_trans": {
            val: "",
            gain_loss: CommonSettings.hardware[partsTypes.TRANSCEIVERS][TRANSCEIVERS_TYPES.GPON].gpon_min_dl_tx
        },
        "gpon_rx_gpon_sens": {
            val: "",
            gain_loss: CommonSettings.hardware[partsTypes.TRANSCEIVERS][TRANSCEIVERS_TYPES.GPON].gpon_min_ul_rx
        },


        "splitter_1": {
            val: SPLITTERS_TYPES.ONEx4,
            gain_loss: ""
        },
        "splitter_2": {
            val: SPLITTERS_TYPES.ONEx12,
            gain_loss: ""
        },
        "splitter_3": {
            val: "",
            gain_loss: ""
        },
        "splice_qty": {
            val: CommonSettings.additional_calc_params[addditionalCalcParams.SPLICE_QTY].defVal,
            gain_loss: ""
        },
        "splice_loss": {
            val: "",
            gain_loss: CommonSettings.additional_calc_params[addditionalCalcParams.SPLICE_LOSS].defVal
        },
        "aging_margin": {
            val: CommonSettings.additional_calc_params[addditionalCalcParams.AGING_MARGIN].defVal,
            gain_loss: ""
        },
        "aging_margin_enable": {
            val: false,
            gain_loss: ""
        },
        "connectors": {
            val: CommonSettings.additional_calc_params[addditionalCalcParams.CONNECTORS].defVal,
            gain_loss: ""
        },
        "connector_loss": {
            val: "",
            gain_loss: CommonSettings.additional_calc_params[addditionalCalcParams.CONNECTOR_LOSS].defVal
        },
        "measurement_error": {
            val: "",
            gain_loss: CommonSettings.additional_calc_params[addditionalCalcParams.MEASUREMENT_ERROR_GAIN_LOSS].defVal
        },
        "total_distance": {
            val: CommonSettings.additional_calc_params[addditionalCalcParams.TOTAL_DISTANCE].defVal,
            gain_loss: ""
        },
        "total_distance_measure": {
            val: window.navigator.language === 'en-US' ? DISTANCE_MEASURES.MIL : CommonSettings.additional_calc_params[addditionalCalcParams.TOTAL_DISTANCE_MEASURE].defVal
        },
        "margin_requirement": {
            val: CommonSettings.additional_calc_params[addditionalCalcParams.MARGIN_REQUIREMENT].defVal
        },
        "xgs_pon_downstream_loss": {
            val: "",
            gain_loss: CommonSettings.loss[lossTypes.FIBER_LOSS].xgs_pon_downstream.loss_per_km
        },
        "gpon_downstream_loss": {
            val: "",
            gain_loss: CommonSettings.loss[lossTypes.FIBER_LOSS].gpon_downstream.loss_per_km
        },
        "xgs_pon_upstream_loss": {
            val: "",
            gain_loss: CommonSettings.loss[lossTypes.FIBER_LOSS].xgs_pon_upstream.loss_per_km
        },
        "gpon_upstream_loss": {
            val: "",
            gain_loss: CommonSettings.loss[lossTypes.FIBER_LOSS].gpon_upstream.loss_per_km
        },
    },
    result: {
        uplink: {
            xgspon: {
                "transceiver_res": {
                    val: "--"
                },
                "splitter_res": {
                    val: "--"
                },
                "splice_qty_res": {
                    val: "--"
                },
                "aging_margin_res": {
                    val: "--"
                },
                "connectors_res": {
                    val: "--"
                },
                "measurement_error_res": {
                    val: "--"
                },
                "total_distance_res": {
                    val: "--"
                },
                "budget_result_xgspon": {
                    val: "--"
                }
            },
            gpon: {
                "transceiver_res": {
                    val: "--"
                },
                "splitter_res": {
                    val: "--"
                },
                "splice_qty_res": {
                    val: "--"
                },
                "aging_margin_res": {
                    val: "--"
                },
                "connectors_res": {
                    val: "--"
                },
                "measurement_error_res": {
                    val: "--"
                },
                "total_distance_res": {
                    val: "--"
                },
                "budget_result_gpon": {
                    val: "--"
                }
            }
        },
        downlink: {
            xgspon: {
                "transceiver_res": {
                    val: "--"
                },
                "splitter_res": {
                    val: "--"
                },
                "splice_qty_res": {
                    val: "--"
                },
                "aging_margin_res": {
                    val: "--"
                },
                "connectors_res": {
                    val: "--"
                },
                "measurement_error_res": {
                    val: "--"
                },
                "total_distance_res": {
                    val: "--"
                },
                "budget_result_xgspon": {
                    val: "--"
                }
            },
            gpon: {
                "transceiver_res": {
                    val: "--"
                },
                "splitter_res": {
                    val: "--"
                },
                "splice_qty_res": {
                    val: "--"
                },
                "aging_margin_res": {
                    val: "--"
                },
                "connectors_res": {
                    val: "--"
                },
                "measurement_error_res": {
                    val: "--"
                },
                "total_distance_res": {
                    val: "--"
                },
                "budget_result_gpon": {
                    val: "--"
                }
            }
        }
    }
};

enum LSEnum {
    FIBER_LS_NAME = "fiber_calc_state"
}
const LSAppVer = process.env.REACT_APP_VERSION ? `_${process.env.REACT_APP_VERSION.replaceAll('.', '_')}` : ''
const LSStateName = `${LSEnum.FIBER_LS_NAME}${LSAppVer}`
const LSState = JSON.parse(localStorage.getItem(LSStateName) || '{}');

export const calculatorSlice = createSlice({
    name: 'calculator',
    initialState: (Object.keys(LSState).length && LSState) || initialConfigState,
    reducers: {
        // Use the PayloadAction type to declare the contents of `action.payload`
        updateField: (state, action: PayloadAction<any>) => {
            if (action.payload.valueID) {
                state.values[action.payload.id][action.payload.valueID] = action.payload.val;
            } else {
                state.values[action.payload.id].val = action.payload.val;
            }
            localStorage.setItem(LSStateName, JSON.stringify(state))
        },
        updateFieldsPack: (state, action: PayloadAction<any>) => {
            if (action.payload.fieldsPack) {
                Object.keys(action.payload.fieldsPack).forEach((id: string) => {
                    const target = state.values[id];
                    Object.keys(target).forEach((field: string) => {
                        state.values[id][field] = action.payload.fieldsPack[id][field]
                    })
                })
                localStorage.setItem(LSStateName, JSON.stringify(state))
            } else {
                console.error('no fileds for update!')
            }
        },
        resetValues: (state) => {
            const restrictedKeys = [
                "xgs_pon_tx_comb_trans", 
                "gpon_tx_comb_trans", 
                "xgs_pon_rx_comb_trans_sens",
                "gpon_rx_comb_trans_sens",
                "xgs_pon_tx_xgs_trans",
                "xgs_pon_rx_xgs_trans_sens",
                "gpon_tx_gpon_trans",
                "gpon_rx_gpon_sens",
            ]
            splitterIDs.forEach((num: number) => {
                restrictedKeys.push(`splitters_loss_1x${num}`)
            })
            state.result = initialConfigState.result

            Object.keys(state.values).forEach(key => {
                if(!restrictedKeys.includes(key)) {
                    state.values[key] = initialConfigState.values[key]
                }
            })

            localStorage.setItem(LSStateName, JSON.stringify(state))
        },
        recalcValues: (state) => {
            const agingMarginEnable = state.values["aging_margin_enable"].val
            // Recalc Gain/Loss
            state.values["splitter_1"].gain_loss = notEmptyVal(state.values["splitter_1"].val) ? state.values[`splitters_loss_${state.values["splitter_1"].val}`].gain_loss : ""
            state.values["splitter_2"].gain_loss = notEmptyVal(state.values["splitter_2"].val) ? state.values[`splitters_loss_${state.values["splitter_2"].val}`].gain_loss : ""
            state.values["splitter_3"].gain_loss = notEmptyVal(state.values["splitter_3"].val) ? state.values[`splitters_loss_${state.values["splitter_3"].val}`].gain_loss : ""
            state.values["splice_qty"].gain_loss = notEmptyVal(state.values["splice_qty"].val) ? state.values["splice_qty"].val * state.values["splice_loss"].gain_loss : 0;
            if (!agingMarginEnable) {
                state.values["aging_margin"].gain_loss = 0;
            } else {
                state.values["aging_margin"].gain_loss = notEmptyVal(state.values["aging_margin"].val) ? state.values["aging_margin"].val : 0;
            }
            state.values["connectors"].gain_loss = notEmptyVal(state.values["connectors"].val) ? state.values["connectors"].val * state.values["connector_loss"].gain_loss : 0;
            // Recalc Budget Section
            const distanceMeasureRecalcVal = state.values["total_distance_measure"].val === DISTANCE_MEASURES.MIL ? state.values["total_distance"].val * 1.60934 : state.values["total_distance"].val
            
            const calcSumHelper = (props: any) => {
                const { 
                    transceiver_res, 
                    splitter_res, 
                    splice_qty_res, 
                    aging_margin_res, 
                    connectors_res, 
                    measurement_error_res, 
                    total_distance_res 
                } = props
                const sum = transceiver_res.val + 
                splitter_res.val + splice_qty_res.val + 
                aging_margin_res.val + connectors_res.val + 
                measurement_error_res.val + total_distance_res.val;
                return sum.toFixed(1);
            }
            
            const calcDownLinkXGSPON = () => {
                // Downlink XGSPON
                switch (state.values["transceiver_1"].val) {
                    case TRANSCEIVERS_TYPES.COMBO_PON:
                        state.result.downlink.xgspon["transceiver_res"].val = state.values["xgs_pon_tx_comb_trans"].gain_loss
                        break;
                    case TRANSCEIVERS_TYPES.XGS_PON:
                        state.result.downlink.xgspon["transceiver_res"].val = state.values["xgs_pon_tx_xgs_trans"].gain_loss
                        break;
                    default:
                        break;
                }
                state.result.downlink.xgspon["splitter_res"].val = -(state.values["splitter_1"].gain_loss + state.values["splitter_2"].gain_loss + state.values["splitter_3"].gain_loss)
                state.result.downlink.xgspon["splice_qty_res"].val = -(state.values["splice_qty"].gain_loss)
                state.result.downlink.xgspon["aging_margin_res"].val = agingMarginEnable ? -state.values["aging_margin"].gain_loss : 0
                state.result.downlink.xgspon["connectors_res"].val = -state.values["connectors"].gain_loss
                state.result.downlink.xgspon["measurement_error_res"].val = -state.values["measurement_error"].gain_loss
                state.result.downlink.xgspon["total_distance_res"].val = -distanceMeasureRecalcVal * state.values["xgs_pon_downstream_loss"].gain_loss
                state.result.downlink.xgspon["budget_result_xgspon"].val = calcSumHelper(state.result.downlink.xgspon)
            }
            const calcDownLinkGPON = () => {
                // Downlink GPON
                switch (state.values["transceiver_1"].val) {
                    case TRANSCEIVERS_TYPES.COMBO_PON:
                        state.result.downlink.gpon["transceiver_res"].val = state.values["gpon_tx_comb_trans"].gain_loss
                        break;
                    case TRANSCEIVERS_TYPES.GPON:
                        state.result.downlink.gpon["transceiver_res"].val = state.values["gpon_tx_gpon_trans"].gain_loss
                        break;
                    default:
                        break;
                }
                state.result.downlink.gpon["splitter_res"].val = -(state.values["splitter_1"].gain_loss + state.values["splitter_2"].gain_loss + state.values["splitter_3"].gain_loss)
                state.result.downlink.gpon["splice_qty_res"].val = -(state.values["splice_qty"].gain_loss)
                state.result.downlink.gpon["aging_margin_res"].val = agingMarginEnable ? -state.values["aging_margin"].gain_loss : 0
                state.result.downlink.gpon["connectors_res"].val = -state.values["connectors"].gain_loss
                state.result.downlink.gpon["measurement_error_res"].val = -state.values["measurement_error"].gain_loss
                state.result.downlink.gpon["total_distance_res"].val = -distanceMeasureRecalcVal * state.values["gpon_downstream_loss"].gain_loss
                state.result.downlink.gpon["budget_result_gpon"].val = calcSumHelper(state.result.downlink.gpon)
            }
            const calcUpLinkXGSPON = () => {
                // Downlink XGSPON
                state.result.uplink.xgspon["transceiver_res"].val = CommonSettings.hardware[partsTypes.ONTS][ONTS_TYPES.SXX00].min_dl_tx
                state.result.uplink.xgspon["splitter_res"].val = -(state.values["splitter_1"].gain_loss + state.values["splitter_2"].gain_loss + state.values["splitter_3"].gain_loss)
                state.result.uplink.xgspon["splice_qty_res"].val = -(state.values["splice_qty"].gain_loss)
                state.result.uplink.xgspon["aging_margin_res"].val = agingMarginEnable ? -state.values["aging_margin"].gain_loss : 0
                state.result.uplink.xgspon["connectors_res"].val = -state.values["connectors"].gain_loss
                state.result.uplink.xgspon["measurement_error_res"].val = -state.values["measurement_error"].gain_loss
                state.result.uplink.xgspon["total_distance_res"].val = -distanceMeasureRecalcVal * state.values["xgs_pon_upstream_loss"].gain_loss
                state.result.uplink.xgspon["budget_result_xgspon"].val = calcSumHelper(state.result.uplink.xgspon)
            }
            const calcUpLinkGPON = () => {
                // Uplink GPON
                state.result.uplink.gpon["transceiver_res"].val = CommonSettings.hardware[partsTypes.ONTS][ONTS_TYPES.SGX00].min_dl_tx
                state.result.uplink.gpon["splitter_res"].val = -(state.values["splitter_1"].gain_loss + state.values["splitter_2"].gain_loss + state.values["splitter_3"].gain_loss)
                state.result.uplink.gpon["splice_qty_res"].val = -(state.values["splice_qty"].gain_loss)
                state.result.uplink.gpon["aging_margin_res"].val = agingMarginEnable ? -state.values["aging_margin"].gain_loss : 0
                state.result.uplink.gpon["connectors_res"].val = -state.values["connectors"].gain_loss
                state.result.uplink.gpon["measurement_error_res"].val = -state.values["measurement_error"].gain_loss
                state.result.uplink.gpon["total_distance_res"].val = -distanceMeasureRecalcVal * state.values["gpon_upstream_loss"].gain_loss
                state.result.uplink.gpon["budget_result_gpon"].val = calcSumHelper(state.result.uplink.gpon)
            }
            calcDownLinkXGSPON();
            calcDownLinkGPON();
            calcUpLinkXGSPON();
            calcUpLinkGPON();
            state.values.total_distance.gain_loss = {
                xgspon: {
                    upstream: state.result.uplink.xgspon["total_distance_res"].val,
                    downstream: state.result.downlink.xgspon["total_distance_res"].val,
                },
                gpon: {
                    upstream: state.result.uplink.gpon["total_distance_res"].val,
                    downstream: state.result.downlink.gpon["total_distance_res"].val,
                }
            }
        },
    },
});

export const { updateField, updateFieldsPack, recalcValues, resetValues } = calculatorSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.calculator.value)`
export const selectConfigState = (state: RootState) => state.calculator.values;
export const selectContentState = (state: RootState) => state.calculator.result;

export default calculatorSlice.reducer;
